import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
import {useModal} from 'extensions/viewport/useModal';
import {Prompt} from 'interface/base/Prompt';

export function useModalFlags(message: string) {
  const {t} = useLingui();
  const modal = useModal();

  const open = useCallback(() => {
    modal.open(
      <Prompt
        title={t`File Restricted`}
        text={message}
        buttons={[
          {
            mode: 'primary',
            text: t`Ok`.toUpperCase(),
            onPress: modal.exit,
          },
        ]}
      />
    );
  }, [message, modal, t]);

  return {open, exit: modal.exit};
}
